import { scheme } from "vega";

const category20b = scheme("category20b");

export const colorScheme: string[] = Array.from(category20b);
for (let i = 0; i < colorScheme.length; i++) {
  const x = i % 5;
  const y = Math.floor(i / 5);
  colorScheme[i] = category20b[x * 4 + y];
}
